import { styled } from 'styled-components'

export const StyledReviewsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`
